// React
import React from 'react';

// Vendors
import { Outlet } from 'react-router-dom';

// Src
import TheCanvasHeader from './components/TheCanvasHeader/TheCanvasHeader';

// Styles
import classes from './CanvasLayout.module.scss';

const CanvasLayout = () => (
    <div className={classes.Root}>
        <TheCanvasHeader />

        <div className={classes.Content}>
            <Outlet />
        </div>
    </div>
);

export default CanvasLayout;
